// extracted by mini-css-extract-plugin
export default {"labelWithLink":"LabelWithLink-module__labelWithLink--c3sFj"};